import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { ModalComponent } from '../modal/modal.component';
import { CommonModule } from '@angular/common';
import { OtpComponent } from 'npx-arc-ui/otp-input';

enum Data{
  CORREO = 1,
  QR,SMS=3
}

@Component({
  selector: 'app-modal-double-factor',
  templateUrl: './modal-double-factor.component.html',
  styleUrls: ['./modal-double-factor.component.scss'],
  standalone: true,
  imports: [
    ModalComponent
    , CommonModule
    , FormsModule
    , ReactiveFormsModule
    , OtpComponent
  ]
})
export class ModalDoubleFactorComponent{
  selectedValue: string = "";
  hasWhatsapp: boolean = false;
  largoCodigo: number = 5;
  codigoCtrl = new FormControl('', [Validators.required]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { code: number, qr: string | null }
  , public appStateService: AppStateService
  , public dialogRef: MatDialogRef<ModalDoubleFactorComponent>) 
  {
    this.largoCodigo = data.code === Data.QR ? 6 : 5
  }

  get isQR(): boolean{
    return this.data.code === Data.QR;
  }

  get isEmail(): boolean {
    return this.data.code === Data.CORREO;
  }
  
  get isSMS(): boolean {
    return this.data.code === Data.SMS;
  }

  validationOTPCode(): boolean{
    const { value: codigo } = this.codigoCtrl;
    const c = [...String(codigo)];
    if (c.length < 5) return true;
    return false;
  }


  VerifyCode = () =>
    this.appStateService.UserService
    .VerifyCode(String(this.codigoCtrl.value), String(this.data.code), 1)
    .subscribe(({success}) =>{
      if(success){
        this.onClose({ action: 'reload' })
      }
    });

  SendCode(){
    this.appStateService.UserService
    .SendCode("")
    .subscribe();
  }

  setTwoFactor(){
    this.appStateService.TwoFactorService
    .setTwoFactor(String(this.data.code))
    .subscribe();
  }

  showInsertCode(){
    this.appStateService.TwoFactorService
    .setTwoFactor(String(this.data.code),this.selectedValue)
    .subscribe();
    this.hasWhatsapp = true;
  }

  onClose = (data?: { [key: string]: any }) => this.dialogRef.close({ ...data })
}
